var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"faq-arrow-icon icon"},[_c('svg',{attrs:{"width":"7","height":"5","viewBox":"0 0 7 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.49984 -5.29972e-07L6.53093 4.5L0.468751 4.5L3.49984 -5.29972e-07Z","fill":"#2A3742"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }